/* esm.sh - rfc4648@1.5.0 */
export * from "https://esm.sh/v94/rfc4648@1.5.0/deno/rfc4648.js";
export { default } from "https://esm.sh/v94/rfc4648@1.5.0/deno/rfc4648.js";
